import React from "react";
import CategoryPage from "./CategoryPage";

function HerSpace({
  posts,
  publications
}) {

  return (
    <CategoryPage
      title="Her Space"
      parentCategory="Articles"
      posts={posts}
      publications={publications}
    />
  );

}

export default HerSpace;